import type { User } from './api.ts'

/**
 * Navigation model. `ownerOnly` items are hidden from the salesperson — the
 * visible proof that roles work (JK sees a different menu than MP/BT). This is
 * only cosmetic; the real barrier is the database role, which makes purchase
 * prices and margins unreadable to sales even via the API (criterion #4).
 *
 * Most items are placeholders for later stages — they render an "coming in
 * stage N" page for now, so the shell is walkable end to end today.
 */
export interface NavItem {
  path: string
  label: string
  stage: number
  ownerOnly?: boolean
}

const ALL_ITEMS: NavItem[] = [
  { path: '/', label: 'Pulpit', stage: 7 },
  { path: '/katalog', label: 'Katalog maszyn', stage: 2 },
  { path: '/klienci', label: 'Klienci', stage: 3 },
  { path: '/oferty', label: 'Oferty', stage: 4 },
  { path: '/zamowienia', label: 'Zamówienia', stage: 5 },
  { path: '/magazyn', label: 'Magazyn', stage: 6 },
  { path: '/serwis', label: 'Serwis', stage: 7 },
  { path: '/zadania', label: 'Zadania', stage: 7 },
  { path: '/raporty', label: 'Raporty', stage: 9, ownerOnly: true },
  { path: '/ustawienia', label: 'Ustawienia', stage: 1, ownerOnly: true },
]

export function navFor(user: User): NavItem[] {
  const isOwner = user.role === 'wlasciciel'
  return ALL_ITEMS.filter((item) => !item.ownerOnly || isOwner)
}

export function roleLabel(role: User['role']): string {
  switch (role) {
    case 'wlasciciel':
      return 'Właściciel'
    case 'handlowiec':
      return 'Menadżer sprzedaży'
    case 'serwis':
      return 'Serwis'
  }
}
